export const getUrlQueryParam = (queryParamName) => {
  const inputQueryParamName = queryParamName || '';
  if (!inputQueryParamName) {
    return '';
  }
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(queryParamName) || '';
};
